<template>
  <el-row>
    <el-dialog :title="$t('1752')" :visible.sync="visible" append-to-body :close-on-click-modal="false" width="720px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <!-- 周期开始日期 -->
        <el-form-item :label="$t('1748')" prop="start_date">
          <el-date-picker
            v-model="ruleForm.start_date"
            value-format="yyyy-MM-dd"
            type="date"
            :placeholder="$t('878')"
            :picker-options="{ disabledDate }"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 此日期之前也按照相应规律排班 -->
        <el-form-item :label="$t('1750')" prop="region">
          <el-checkbox v-model="ruleForm.is_before">{{ $t('1751') }}</el-checkbox>
        </el-form-item>
      </el-form>
      <!-- 底部操作栏 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{ $t('66') }}</el-button>
        <el-button type="primary" plain @click="doSubmint" :loading="loading">{{ $t('131') }}</el-button>
      </span>
    </el-dialog>
  </el-row>
</template>

<script>
import { round_add_staff_shift_cycle } from 'api/Attendance'
export default {
  data() {
    return {
      visible: false,
      loading: false, // 提交按钮loading
      ruleForm: {
        id: '',
        month: new Date(), // 限制月份
        is_before: false, // 必须是否此日期之前也按照相应规律排班，
        start_date: '' // 开始时间
      } // 表单
    }
  },

  methods: {
    init(params) {
      const { id, date } = params
      this.ruleForm.month = date
      this.ruleForm.id = id
      this.visible = true
      this.generateDate(date)
    },
    // 如果是当前月 则展示当天 其他展示1号
    generateDate(date) {
      const currentDate = new Date()
      if (date.getMonth() === currentDate.getMonth()) {
        this.ruleForm.start_date = this.$util.parseTime(currentDate, '{y}-{m}-{d}')
      } else {
        const targetDate = new Date(date.getFullYear(), date.getMonth(), 1)
        this.ruleForm.start_date = this.$util.parseTime(targetDate, '{y}-{m}-{d}')
      }
    },
    // 时间选择禁用 必须是当前月
    disabledDate(t) {
      const { month } = this.ruleForm
      const nextMonth = new Date(month.getFullYear(), month.getMonth() + 1, 1)
      return t.getTime() < month.getTime() || t.getTime() >= nextMonth.getTime()
    },
    // 日期格式补全
    createNum(num) {
      return num < 10 ? `0${num}` : num
    },
    doSubmint() {
      const { month } = this.ruleForm
      const m = this.createNum(month.getMonth() + 1)
      const msg = {
        ...this.ruleForm,
        month: `${month.getFullYear()}-${m}`
      }
      round_add_staff_shift_cycle(msg).then(res => {
        this.visible = false
        this.$emit('update')
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
